import { render } from "./RequisiteTemplatesPopup.vue?vue&type=template&id=5f1a02bc&ts=true"
import script from "./RequisiteTemplatesPopup.vue?vue&type=script&lang=ts"
export * from "./RequisiteTemplatesPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__